import { isInViewport, debounce } from '@everberg/lib/helpers';

function scrollAnimate() {
	const className = 'js-scroll-animate';
	const elements = [...document.querySelectorAll(`.${className}`)];
	const enabledBreakpoint = 1024;

	const init = () => {
		animate();

		window.addEventListener('scroll', animate, {
			capture: false,
			passive: true,
		});

		window.addEventListener('load', animate, false);

		window.addEventListener('resize', debounce(animate));
	};

	const animationsEnabled = () => {
		return window.innerWidth >= enabledBreakpoint;
	};

	const animate = () => {
		if (!elements.length || !animationsEnabled()) {
			return false;
		}

		elements.forEach((el, index) => {
			if (!el.classList.contains(className)) {
				return false;
			}

			if (isInViewport(el)) {
				el.classList.remove(className);
				elements.splice(index, 1);
			}
		});
	};

	init();
}

export default scrollAnimate;
